import { RingPositions } from "shared/constants/ringPositionType"
import { ExtraGridConditionType } from "shared/pages/opencallsPage/GetCompetitionItem/types/extraGridConditionType";

export enum DafesProjectType {
    design = 0,
    art = 1,
    fashion = 2,
    education = 3,
    startups = 4,
    dafesPlus = 5,
}

interface CompetitionCardModalProps {
    isModalCard?: boolean;
    isSelected?: boolean;
    isAlready?: boolean;
    selectRingPosition?: RingPositions;
    onSelect?: (projectId: string) => void;
}

export interface CompetitionCardProps extends CompetitionCardModalProps {
    competitionProps: any;
    isNewType: boolean;
    notClickableTags?: boolean;
    isProfile?: boolean;
    isMainPage?: boolean;
    extraGridCondition?: ExtraGridConditionType;
    currentTagId?: string;
    addParams?: { sorting: number };
}

export interface OptionProps {
    name: string;
    identifier: number;
}import { RingPositions } from "shared/constants/ringPositionType"
import { ExtraGridConditionType } from "shared/pages/opencallsPage/GetCompetitionItem/types/extraGridConditionType";

export enum DafesProjectType {
    design = 0,
    art = 1,
    fashion = 2,
    education = 3,
    startups = 4,
    dafesPlus = 5,
}

interface CompetitionCardModalProps {
    isModalCard?: boolean;
    isSelected?: boolean;
    isAlready?: boolean;
    selectRingPosition?: RingPositions;
    onSelect?: (projectId: string) => void;
}

export interface CompetitionCardProps extends CompetitionCardModalProps {
    competitionProps: any;
    isNewType: boolean;
    notClickableTags?: boolean;
    isProfile?: boolean;
    isMainPage?: boolean;
    extraGridCondition?: ExtraGridConditionType;
    currentTagId?: string;
    addParams?: { sorting: number };
}

export interface OptionProps {
    name: string;
    identifier: number;
}